import { Subject } from 'helpers/store';
import { useApplicationSetup } from 'services/use-application-setup';

class ConfigStore {
  public config$ = new Subject<ReturnType<typeof useApplicationSetup>>({ replay: true });

  public siteCount$ = new Subject<number>({ replay: true });
}

(window as any).configStore = new ConfigStore();

export const configStore = (window as any).configStore as ConfigStore;
